import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import Select from 'react-select';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import Decimal from 'decimal.js';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { MAX_LIMIT } from 'modules/common/constants';
import { ModalContext } from 'App';
import * as c from '../constant';
import * as actions from '../action';

function UpdateModal({
  updateNewOtherFees,
  // getNewOtherFeesList,
  updateList,
  id,
  history,
  getSingleNewOtherFees,
  updating,
  ordinanceRevisionId,
  getEndorsingOfficesList,
  endorsingOfficesList,
  dataInfo,
}) {
  const [formData, setFormData] = useState({
    code: '',
    description: '',
    amount: '',
    percentage: '',
    type: '',
    for_new: 0,
    for_renewal: 0,
    endorsing_office_id: '',
    column_property: '',
    minimum_amount: '',
    maximum_amount: '',
    fee_type: '',
    exclude_delinquent: 0,
    label: '',
  });

  const validateForm = useFormValidator(formData, {
    code: 'required',
    description: 'required',
    type: 'required',
    fee_type: 'required',
    amount: 'required_if:type=BARANGAY CLEARANCE|required_if:type=BASIC',
    percentage: 'required_if:type=FIRE SAFETY',
    minimum_amount: 'required_if:type=FIRE SAFETY',
    maximum_amount: 'required_if:type=FIRE SAFETY',
    column_property: 'required_if:type=OPTION|required_if:type=RANGE',
  });

  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      ...formData,
      code: _.get(formData, 'code').toUpperCase(),
      ordinance_revision_id: ordinanceRevisionId,
    };

    let message = 'Are you sure you want to update other fee?';

    if (
      updateList.fee_type === 'SPECIFIC_FEE' &&
      formData.fee_type === 'COMMON_FEE'
    ) {
      message = 'Changing Specific fee to Common fee will un-tag this to Business line(s). Are you sure you want to continue?';
    }

    ConfirmAlert(
      message,
      () => {
        updateNewOtherFees(id, args, ({ data }) => {
          setModal({ isOpen: false });
          getSingleNewOtherFees(id);
          history.push(
            `/bpls/tax-revenue/new-other-fees/${_.get(data, 'id')}`
          );
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
        endorsing_office_id: _.get(dataInfo, 'included.endorsingOffice.id'),
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, []);

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const onCheck = (e) => {
    const { name, checked } = e.target;
    setFormData({
      ...formData,
      [name]: checked ? 1 : 0,
      ...(name === 'for_renewal' && !checked && { exclude_delinquent: 0 }),
    });
  };

  const handleOnChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  useEffect(() => {
    getEndorsingOfficesList();
  }, []);

  const selectEndorsingOffice = endorsingOfficesList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const handleDropDownChange = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const findValue =
    selectEndorsingOffice.find(
      (item) => +_.get(formData, 'endorsing_office_id') === +item.id
    ) || '';

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Code: {validateForm.renderMessage('code')}
            </label>
            <input
              className="form-control"
              type="text"
              name="code"
              onChange={onChange}
              placeholder="Ex. CODE-1234"
              style={{ textTransform: 'uppercase' }}
              value={_.get(formData, 'code') || ''}
              disabled
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Description: {validateForm.renderMessage('description')}
            </label>
            <input
              className="form-control"
              type="text"
              name="description"
              onChange={onChange}
              value={_.get(formData, 'description') || ''}
              disabled
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Type: {validateForm.renderMessage('type')}
            </label>
            <Select
              name="type"
              placeholder="Select Type"
              onChange={handleOnChangeSelect('type')}
              options={c.OTHER_FEE_TYPE}
              value={
                c.OTHER_FEE_TYPE.find(
                  (item) => _.get(formData, 'type') === _.get(item, 'value')
                ) || ''
              }
              isDisabled
              isClearable
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Fee Type: {validateForm.renderMessage('fee_type')}
            </label>
            <Select
              name="fee_type"
              placeholder="Select Fee Type"
              onChange={handleOnChangeSelect('fee_type')}
              options={c.FEE_TYPE}
              value={
                c.FEE_TYPE.find(
                  (item) => _.get(formData, 'fee_type') === _.get(item, 'value')
                ) || ''
              }
              isClearable
              isDisabled={_.get(formData, 'type') === 'BARANGAY CLEARANCE'}
            />
          </div>
          {['BARANGAY CLEARANCE', 'BASIC'].indexOf(_.get(formData, 'type')) >
            -1 && (
            <div className="col-12 form-group">
              <label className="full-label mb-0">
                Amount: {validateForm.renderMessage('amount')}
              </label>
              <NumberFormat
                name="amount"
                id="amount"
                placeholder="0.00"
                className="form-control"
                onValueChange={(values) => {
                  const { value } = values;
                  const props = {
                    target: {
                      name: 'amount',
                      value,
                    },
                  };
                  onChange(props);
                }}
                displayType="input"
                decimalScale={2}
                isNumericString
                allowNegative
                thousandSeparator
                allowLeadingZeros
                prefix="₱ "
                value={_.get(formData, 'amount')}
                isAllowed={(values) => {
                  const { value } = values;
                  if (!value) return true;
                  const val = new Decimal(value);
                  const max = new Decimal(MAX_LIMIT);
                  return value === undefined || val.lte(max);
                }}
              />
            </div>
          )}
          {['BASIC', 'FIRE SAFETY'].indexOf(_.get(formData, 'type')) > -1 && (
            <div className="col-12 form-group">
              <label className="full-label mb-0">Endorsing Office:</label>
              <Select
                options={selectEndorsingOffice}
                placeholder="Search for office..."
                onChange={handleDropDownChange('endorsing_office_id')}
                value={findValue}
                isClearable
              />
            </div>
          )}
          {['VETERINARY', 'ZONING PROCESSING', 'FIRE SAFETY'].indexOf(
            _.get(formData, 'type')
          ) > -1 && (
            <div className="col-12 form-group">
              <label className="full-label mb-0">
                Percentage: {validateForm.renderMessage('percentage')}
              </label>
              <input
                className="form-control"
                type="text"
                name="percentage"
                onChange={onChange}
                value={_.get(formData, 'percentage') || ''}
              />
            </div>
          )}
          {['RANGE', 'OPTION'].indexOf(_.get(formData, 'type')) > -1 && (
            <div className="col-12 form-group">
              <label className="full-label mb-0">
                Multiplier: {validateForm.renderMessage('column_property')}
              </label>
              <input
                className="form-control"
                type="text"
                name="column_property"
                onChange={onChange}
                value={_.get(formData, 'column_property') || ''}
              />
            </div>
          )}
          {['FIRE SAFETY'].indexOf(_.get(formData, 'type')) > -1 && (
            <div className="col-12 form-group">
              <label className="full-label mb-0">
                Minimum Amount: {validateForm.renderMessage('minimum_amount')}
              </label>
              <NumberFormat
                name="minimum_amount"
                id="minimum_amount"
                placeholder="0.00"
                className="form-control"
                onValueChange={(values) => {
                  const { value } = values;
                  const props = {
                    target: {
                      name: 'minimum_amount',
                      value,
                    },
                  };
                  onChange(props);
                }}
                displayType="input"
                decimalScale={2}
                isNumericString
                allowNegative
                thousandSeparator
                allowLeadingZeros
                prefix="₱ "
                value={_.get(formData, 'minimum_amount')}
                isAllowed={(values) => {
                  const { value } = values;
                  if (!value) return true;
                  const val = new Decimal(value);
                  const max = new Decimal(MAX_LIMIT);
                  return value === undefined || val.lte(max);
                }}
              />
            </div>
          )}
          {['FIRE SAFETY'].indexOf(_.get(formData, 'type')) > -1 && (
            <div className="col-12 form-group">
              <label className="full-label mb-0">
                Maximum Amount: {validateForm.renderMessage('maximum_amount')}
              </label>
              <NumberFormat
                name="maximum_amount"
                id="maximum_amount"
                placeholder="0.00"
                className="form-control"
                onValueChange={(values) => {
                  const { value } = values;
                  const props = {
                    target: {
                      name: 'maximum_amount',
                      value,
                    },
                  };
                  onChange(props);
                }}
                displayType="input"
                decimalScale={2}
                isNumericString
                allowNegative
                thousandSeparator
                allowLeadingZeros
                prefix="₱ "
                value={_.get(formData, 'maximum_amount')}
                isAllowed={(values) => {
                  const { value } = values;
                  if (!value) return true;
                  const val = new Decimal(value);
                  const max = new Decimal(MAX_LIMIT);
                  return value === undefined || val.lte(max);
                }}
              />
            </div>
          )}
          {['QUANTITY MATRIX'].indexOf(_.get(formData, 'type')) > -1 && (
            <div className="col-12 form-group">
              <label className="full-label mb-0">Label:</label>
              <input
                className="form-control"
                type="text"
                name="label"
                onChange={onChange}
                value={_.get(formData, 'label') || ''}
              />
            </div>
          )}

          <div className="col-12">
            <div className="form-group">
              <input
                name="for_new"
                type="checkbox"
                checked={_.get(formData, 'for_new') || 0}
                onChange={onCheck}
              />
              <label htmlFor="last_name" className="form-label mx-2 mb-0">
                New
              </label>
            </div>
            <div className="form-group">
              <input
                name="for_renewal"
                type="checkbox"
                checked={_.get(formData, 'for_renewal') || 0}
                onChange={onCheck}
              />
              <label htmlFor="last_name" className="form-label mx-2 mb-0">
                Renewal
              </label>
            </div>
            <div className="form-group">
              <input
                name="exclude_delinquent"
                type="checkbox"
                checked={_.get(formData, 'exclude_delinquent') || 0}
                onChange={onCheck}
              />
              <label htmlFor="last_name" className="form-label mx-2 mb-0">
                Exclude Delinquent
              </label>
            </div>
            {_.get(formData, 'type') !== 'BARANGAY CLEARANCE' && (
              <div className="form-group">
                <input
                  name="for_retirement"
                  type="checkbox"
                  checked={_.get(formData, 'for_retirement') || 0}
                  onChange={onCheck}
                />
                <label htmlFor="last_name" className="form-label mx-2 mb-0">
                  Retirement
                </label>
              </div>
            )}
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={updating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary     mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>{' '}
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  updateList: PropTypes.instanceOf(Object).isRequired,
  updateNewOtherFees: PropTypes.instanceOf(Function).isRequired,
  // getNewOtherFeesList: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleNewOtherFees: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
  getEndorsingOfficesList: PropTypes.instanceOf(Function).isRequired,
  endorsingOfficesList: PropTypes.instanceOf(Object).isRequired,
  dataInfo: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_NEW_OTHER_FEES) > -1,
  endorsingOfficesList: _.get(api, `${c.GET_ENDORSING_OFFICES}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
